import { useState } from 'react';
import './AltLanding3.css';

const funFacts = [
  "Jason maintains a Top 10 favorite TV show list. The top three—Succession, Westworld, and Dark—are considered stable. The remaining seven are subject to periodic review.",
  "Jason lives in the Notes app. It contains evolving gift ideas, travel checklists, workout splits, app ideas, and several items whose original purpose is no longer clear.",
  "Jason tore his achilles tendon on March 22, 2025 at approx. 10 AM CT on a turf field in Round Rock, TX.",
  "Jason loves learning TV themes and pop songs on the piano.",
  "Jason was voted 'Most Likely to Be President' in eighth grade. This has yet to materialize.",
  "Jason had a 70 minute commute to high school.",
  "Jason wrote these facts in the third person to maintain objectivity.",
];

function AltLanding3() {
  const [activeTab, setActiveTab] = useState('career');
  const [factHistory, setFactHistory] = useState([0]);
  const [historyIndex, setHistoryIndex] = useState(0);
  const [sliding, setSliding] = useState(false);

  const nextFact = () => {
    setSliding(true);
    setTimeout(() => {
      const nextIdx = (factHistory[historyIndex] + 1) % funFacts.length;
      const newHistory = [...factHistory.slice(0, historyIndex + 1), nextIdx];
      setFactHistory(newHistory);
      setHistoryIndex(newHistory.length - 1);
      setSliding(false);
    }, 200);
  };

  const prevFact = () => {
    if (historyIndex > 0) {
      setSliding(true);
      setTimeout(() => {
        setHistoryIndex(historyIndex - 1);
        setSliding(false);
      }, 200);
    }
  };

  const factIndex = factHistory[historyIndex];

  return (
    <div className="alt3-page">
      <main className="alt3-main">
        <header className="alt3-intro">
          <img
            src="/profile.jpg"
            alt="Jason"
            className="alt3-profile-photo"
          />
          <h1>Hi, I'm Jason</h1>
        </header>

        {/* Minimal Text Toggle */}
        <nav className="alt3-toggle">
          <button
            className={activeTab === 'career' ? 'active' : ''}
            onClick={() => setActiveTab('career')}
          >
            Career
          </button>
          <span className="alt3-divider">/</span>
          <button
            className={activeTab === 'personal' ? 'active' : ''}
            onClick={() => setActiveTab('personal')}
          >
            Personal
          </button>
        </nav>

        {activeTab === 'career' && (
          <div className="alt3-tab-content">
            <section className="alt3-bio">
              <p>
                I'm a backend software engineer in the financial services space. I've focused on building distributed APIs, cloud-native infrastructure, and scalable data pipelines over the past few years, but I'm always looking for the next challenge that pushes me to grow.
              </p>
              <br />
              <p>
                My interest in engineering started in high school, when I built an Android app connected to a 3D-printed smartwatch that vibrated to wake me up when my train reached my stop during my commute — because missing it once was enough motivation. I've been solving practical problems with software ever since.
              </p>
            </section>

            <section className="alt3-timeline">
              <ul className="alt3-timeline-list">
                <li className="alt3-timeline-item">
                  <span className="alt3-timeline-date">2026</span>
                  <span className="alt3-timeline-text">Senior Software Engineer at Capital One — Dallas, TX</span>
                </li>
                <li className="alt3-timeline-item">
                  <span className="alt3-timeline-date">2021</span>
                  <span className="alt3-timeline-text">Software Engineer at Charles Schwab — Austin, TX</span>
                </li>
                <li className="alt3-timeline-item">
                  <span className="alt3-timeline-date">2021</span>
                  <span className="alt3-timeline-text">B.E. in Electrical Engineering, Minor in Computer Science — The Cooper Union, New York, NY</span>
                </li>
              </ul>
            </section>
          </div>
        )}

        {activeTab === 'personal' && (
          <div className="alt3-tab-content">
            <section className="alt3-bio">
              <p>
                I enjoy playing and watching soccer, hip-hop dancing, tumbling, piano, tabletop games, and working out.
              </p>
            </section>

            <section className="alt3-links">
              <ul>
                <li><a href="https://www.goodreads.com/user/show/198095880-jason-kurian" target="_blank" rel="noopener noreferrer">What I'm Reading</a></li>
                <li><a href="https://open.spotify.com/user/jkurian49?si=76f2e83afe484a6d" target="_blank" rel="noopener noreferrer">What I'm Listening To</a></li>
              </ul>
            </section>

            <section className="alt3-fun-facts">
              <div className="alt3-fact-nav">
                <button
                  className={`alt3-fact-arrow ${historyIndex === 0 ? 'disabled' : ''}`}
                  onClick={prevFact}
                  aria-label="Previous fact"
                  disabled={historyIndex === 0}
                >←</button>
                <button className="alt3-fact-arrow" onClick={nextFact} aria-label="Next fact">→</button>
              </div>
              <p className={`alt3-fact-text ${sliding ? 'sliding' : ''}`}>
                {funFacts[factIndex]}
              </p>
            </section>
          </div>
        )}
      </main>

      <footer className="alt3-footer">
        <p>&copy; {new Date().getFullYear()}</p>
      </footer>
    </div>
  );
}

export default AltLanding3;
